import { GET, POST } from "./http.service";

export const getSettings = async () => {
  const response = await GET(`Configuration/dictionary-view`, false);
  return response;
};

export const contactUs = async (requestBody) => {
  const response = await POST(`contactUs`, requestBody, false);
  return response;
};

export const contactUsInfo = async () => {
  const response = await GET(`contactUs/info`, false);
  return response;
};

export const getAllBranches = async () => {
  const response = await GET(`Branch`, false);
  return response;
};

export const getConfigrations = async () => {
  const response = await GET(`Configuration`, false);
  return response;
};
